"use client";

import { useState } from "react";
import { css } from "styled-system/css";
import { HelpCircle } from "lucide-react";

/** Ícono de ayuda con tooltip: hover en desktop, tap en mobile. */
export function InfoTooltip({ text }: { text: string }) {
  const [open, setOpen] = useState(false);

  return (
    <span
      className={css({ position: "relative", display: "inline-flex", verticalAlign: "middle" })}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        aria-label="Más información"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        onBlur={() => setOpen(false)}
        className={css({
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          w: "4.5",
          h: "4.5",
          rounded: "full",
          border: "none",
          bg: "transparent",
          color: "#94a3b8",
          cursor: "pointer",
          p: "0",
          _hover: { color: "#64748b" },
        })}
      >
        <HelpCircle size={15} strokeWidth={1.75} aria-hidden />
      </button>
      <span
        role="tooltip"
        className={css({
          position: "absolute",
          bottom: "calc(100% + 8px)",
          left: "50%",
          transform: "translateX(-50%)",
          w: "max-content",
          maxW: "16rem",
          bg: "#0f172a",
          color: "white",
          fontSize: "xs",
          lineHeight: "1.5",
          fontWeight: "normal",
          p: "2.5",
          rounded: "lg",
          boxShadow: "0 8px 24px rgba(15,23,42,0.25)",
          opacity: open ? 1 : 0,
          visibility: open ? "visible" : "hidden",
          transition: "opacity 125ms ease-out",
          zIndex: 30,
          pointerEvents: "none",
        })}
      >
        {text}
      </span>
    </span>
  );
}
